<script setup lang="ts">
import type { TooltipContentProps } from 'reka-ui'

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'

withDefaults(defineProps<{
  /** Tooltip text — use the #content slot for richer markup */
  content?: string
  side?: TooltipContentProps['side']
  align?: TooltipContentProps['align']
  delayDuration?: number
  contentClass?: string
}>(), {
  side: 'top',
  align: 'center',
  delayDuration: 200,
})
</script>

<template>
  <TooltipProvider :delay-duration="delayDuration">
    <Tooltip>
      <TooltipTrigger as-child>
        <slot />
      </TooltipTrigger>
      <TooltipContent
        :side="side"
        :align="align"
        :avoid-collisions="true"
        :collision-boundary="[]"
        :collision-padding="8"
        sticky="partial"
        :class="contentClass"
        :update-position-strategy="'optimized'"
        :align-offset="4"
        :arrow-padding="4"
        hide-when-detached
        :position-strategy="'absolute'"
      >
        <slot name="content">{{ content }}</slot>
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
</template>
